

/// <reference path="DBImage.ts" />

// Generated class EventProgramImage_ManagedObject

class EventProgramImage_ManagedObject extends DBImage
{
    // Relationship: eventProgram
    set eventProgram(value:EventProgram) {
        this.setValueForKey(value, 'eventProgram');
    }
    get eventProgram():EventProgram {
        return this.valueForKey('eventProgram') as EventProgram;
    }
}
